import MapBrowserEvent from 'ol/MapBrowserEvent'
import { AnnotationManager, IViewerState, ToolTipManager } from '../Viewer.models'

export enum ToolType {
    NONE = 'NONE',
    MEASURING = 'Measure',
    MEASURING_SCALE = 'MeasureScale',
    FREE_POLYGON = 'Polygon',
    CIRCLE = 'Circle',
    SQUARE = 'Square',
    EDIT = 'Modify',
    TEXT = 'Text',
    EDIT_DETAILS = 'Select',
    MOVE = 'Translate',
    MOVE_CANVAS = 'MoveCanvas',
    ROTATION = 'Rotation'
}

export abstract class Tool {
    public type: ToolType = ToolType.NONE;
    protected annotationManager: AnnotationManager
    protected tooltipManager:ToolTipManager
    protected state: IViewerState

    constructor(state: IViewerState, annotationManager: AnnotationManager, tooltipManager:ToolTipManager) {
        this.state = state
        this.annotationManager = annotationManager
        this.tooltipManager = tooltipManager
    }

    public abstract addInteractions(): void
    public abstract removeInteractions(): void

    protected manageClickEvent(event: MapBrowserEvent<MouseEvent>):boolean {
        if ((event.originalEvent as PointerEvent).buttons === 1) {
            return true
        } else {
            return false
        }
    }
}
